import type { PhoneNumber } from "Infrastructure/Api/Api";

export const DEFAULT_PHONE_PREFIX = "+420";

/** Fallback national-number limits used where the per-country limits from the code list
 *  (phoneFormats[].minDigits/maxDigits) are not available — mirror the backend
 *  GetMinPhoneDigits minimum and the PhoneNumber.MaxDigits column capacity. */
export const PHONE_FALLBACK_MIN_DIGITS = 9;
export const PHONE_FALLBACK_MAX_DIGITS = 12;

export const EMPTY_PHONE: PhoneNumber = {
  prefix: DEFAULT_PHONE_PREFIX,
  number: "",
};

/** Type guard: the phone exists and has a national number filled in. */
const hasNationalNumber = (phone?: PhoneNumber | null): phone is PhoneNumber =>
  !!phone?.number;

export const isPhoneEmpty = (phone?: PhoneNumber | null): boolean =>
  !hasNationalNumber(phone);

/** Groups the national number by threes: "654987546" → "654 987 546". */
const groupNationalNumber = (number: string): string =>
  number.replace(/(\d{3})(?=\d)/g, "$1 ");

/** "+420 654 987 546" — for displaying to users. Empty string when the phone is not filled in. */
export const formatPhone = (phone?: PhoneNumber | null): string =>
  hasNationalNumber(phone)
    ? `${phone.prefix} ${groupNationalNumber(phone.number)}`
    : "";

/** "+420739123456" — composed E.164 form for tel: links and integrations. */
export const phoneToE164 = (phone?: PhoneNumber | null): string =>
  hasNationalNumber(phone) ? `${phone.prefix}${phone.number}` : "";
